module.exports = __webpack_public_path__ + "img/site.e9073e73.png";